import { BREAKPOINTS } from "../styles/variables/breakpoints";

const getDeviceInfo = () => {
  if (typeof window === "undefined") {
    return {
      isMobile: false,
      isDesktop: false,
      isHSWeb: false,
      isHSApp: false,
    };
  }

  const width = window.innerWidth;
  const bodyId = document.body?.id;

  const isMobile = width <= BREAKPOINTS.sm;
  const isDesktop = !isMobile;

  const isHSWeb = isMobile && bodyId === "hs-web";
  const isHSApp = isMobile && bodyId === "hs-app";

  return {
    isMobile,
    isDesktop,
    isHSWeb,
    isHSApp,
    width,
  };
};

export { getDeviceInfo };
